import request from '@/utils/request'
import axios from 'axios'

export function textCompletion(prompt) {
  return request({
    url: '/ai/text',
    method: 'post',
    params: { prompt }
  })
}

export function textCompletionStream(prompt, onDelta, onDone, onError) {
  const base = (process.env.VUE_APP_BASE_API || '').replace(/\/$/, '')
  const url = `${base}/ai/text/stream?prompt=${encodeURIComponent(prompt)}`

  return fetch(url, {
    method: 'POST',
    credentials: 'include'
  }).then(async (res) => {
    if (!res.ok) {
      const txt = await res.text().catch(() => '')
      throw new Error(txt || `HTTP ${res.status}`)
    }
    if (!res.body || !res.body.getReader) {
      throw new Error('当前浏览器不支持流式读取')
    }

    const reader = res.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let buffer = ''

    try {
      while (true) {
        const { value, done } = await reader.read()
        if (done) break
        buffer += decoder.decode(value, { stream: true })

        // SSE 按空行分隔事件
        const parts = buffer.split(/\n\n/)
        buffer = parts.pop() || ''
        for (const part of parts) {
          const lines = part.split(/\n/)
          for (const line of lines) {
            const t = line.trim()
            if (t.startsWith('data:')) {
              const data = t.slice(5).trim()
              if (data) {
                onDelta && onDelta(data)
              }
            }
          }
        }
      }
      onDone && onDone()
    } catch (e) {
      onError && onError(e)
      throw e
    }
  }).catch((e) => {
    onError && onError(e)
    throw e
  })
}

// ========== 195-hosted AI utilities (migrated from question.js) ==========

// OCR: image -> questions
export function processOcrImage(formData) {
  // use axios to bypass global interceptors when needed
  return axios({
    url: 'http://123.56.176.195:8000/process_image/',
    method: 'post',
    data: formData,
    timeout: 300000
  })
}

// OCR: generic endpoint (kept for compatibility)
export function importOcrQu(formData) {
  return request({
    url: 'http://123.56.176.195:8000/process/',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// Parse Word doc -> questions
export function parseWordDoc(formData) {
  return request({
    url: 'http://123.56.176.195:8000/parse_doc/',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// Parse AMC PDF -> questions
export function processPdfQuestions(formData) {
  return request({
    url: 'http://123.56.176.195:8000/process_amc_pdf/',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// Legacy PDF parse endpoint used by some views
export function processPdf(formData) {
  return request({
    url: 'http://123.56.176.195:8000/process_pdf/',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// Judge solution with optional image
export function judgeSolution(formData) {
  return request({
    url: 'http://123.56.176.195:7777/judge_solution/',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// Parse AMC markdown -> questions (use axios to avoid global interceptors)
export function getQuestions(formData) {
  return axios({
    url: 'http://123.56.176.195:7777/parse_md_unified/',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    },
    timeout: 300000,
    withCredentials: false,
    baseURL: ''
  }).then(res => res.data)
}
// export function getAmcQuestions(formData) {
//   return axios({
//     url: 'http://123.56.176.195:7777/parse_amc_md/',
//     method: 'post',
//     data: formData,
//     headers: {
//       'Content-Type': 'multipart/form-data',
//       'Accept': 'application/json'
//     },
//     timeout: 300000,
//     withCredentials: false,
//     baseURL: ''
//   }).then(res => res.data)
// }
export function getGespCodeQuestions(formData) {
  return axios({
    url: 'http://123.56.176.195:7777/parse_md_unified/',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    },
    timeout: 300000,
    withCredentials: false,
    baseURL: ''
  }).then(res => res.data)
}
// export function getKangarooQuestions(formData) {
//   return axios({
//     url: 'http://123.56.176.195:7777/parse_kangaroo_md/',
//     method: 'post',
//     data: formData,
//     headers: {
//       'Content-Type': 'multipart/form-data',
//       'Accept': 'application/json'
//     },
//     timeout: 300000,
//     withCredentials: false,
//     baseURL: ''
//   }).then(res => res.data)
// }

export function visionCompletion(imageBase64, prompt) {
  return axios({
    url: process.env.VUE_APP_BASE_API + '/ai/vision',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: new URLSearchParams({
      imageUrl: imageBase64,
      prompt: prompt
    }),
    timeout: 120000,
    withCredentials: true
  }).then(response => {
    return response.data
  })
}

export function uploadAndAnalyzeImage(imageFile, prompt) {
  return new Promise((resolve, reject) => {
    // 创建文件读取器
    const reader = new FileReader()

    // 文件加载完成后的处理
    reader.onload = (e) => {
      // 获取图片Base64数据
      const imageBase64 = e.target.result

      // 创建图片对象用于获取尺寸信息和压缩
      const img = new Image()
      img.onload = () => {
        try {
          // 创建canvas进行压缩
          const canvas = document.createElement('canvas')

          // 根据图片大小决定压缩比例
          let width = img.width
          let height = img.height

          // 计算最佳压缩尺寸 - 基于图片宽高比例
          let MAX_WIDTH = 1200 // 最大宽度
          let MAX_HEIGHT = 1200 // 最大高度
          let compressQuality = 0.7 // 默认压缩质量

          // 如果图片非常大，进一步压缩率
          if (imageFile.size > 5 * 1024 * 1024) { // 5MB以上
            MAX_WIDTH = 800
            MAX_HEIGHT = 800
            compressQuality = 0.6
          }

          // 如果图片特别大，进一步压缩
          if (imageFile.size > 10 * 1024 * 1024) { // 10MB以上
            MAX_WIDTH = 600
            MAX_HEIGHT = 600
            compressQuality = 0.5
          }

          // 计算压缩比例，保持原始宽高比
          let ratio = 1

          if (width > height) {
            if (width > MAX_WIDTH) {
              ratio = MAX_WIDTH / width
            }
          } else {
            if (height > MAX_HEIGHT) {
              ratio = MAX_HEIGHT / height
            }
          }

          // 确保图片尺寸不会过小，这会影响OCR识别
          const MIN_SIZE = 300 // 最小尺寸
          if (width * ratio < MIN_SIZE && height * ratio < MIN_SIZE) {
            ratio = Math.max(MIN_SIZE / width, MIN_SIZE / height)
          }

          // 应用计算出的比例
          width = Math.round(width * ratio)
          height = Math.round(height * ratio)

          // 设置canvas尺寸
          canvas.width = width
          canvas.height = height

          // 将图片绘制到canvas
          const ctx = canvas.getContext('2d')

          // 优化渲染，提高清晰度
          ctx.imageSmoothingEnabled = true
          ctx.imageSmoothingQuality = 'high'

          // 先绘制白色背景（提高某些透明图片的可读性）
          ctx.fillStyle = '#FFFFFF'
          ctx.fillRect(0, 0, width, height)

          // 绘制图片
          ctx.drawImage(img, 0, 0, width, height)

          // 获取压缩后的图片类型
          let imageType = 'image/jpeg' // 默认JPEG

          // 如果原图是PNG且没有透明部分，或文件较小，使用PNG
          if (imageFile.type === 'image/png' && imageFile.size < 2 * 1024 * 1024) {
            imageType = 'image/png'
            compressQuality = 0.8 // PNG一般使用较高质量
          }

          // 获取压缩后的图片数据
          const compressedBase64 = canvas.toDataURL(imageType, compressQuality)

          // 计算压缩比
          const originalSize = Math.round(imageBase64.length / 1024)
          const compressedSize = Math.round(compressedBase64.length / 1024)
          const compressionRatio = Math.round((1 - compressedSize / originalSize) * 100)

          console.log(`原图大小: ${originalSize}KB, 压缩后: ${compressedSize}KB, 压缩率: ${compressionRatio}%, 尺寸: ${width}x${height}`)

          // 显示提示信息
          if (window.Vue && window.Vue.prototype.$message) {
            window.Vue.prototype.$message({
              message: `图片已优化，压缩率${compressionRatio}%`,
              type: 'success',
              duration: 2000
            })
          }

          // 使用压缩后的数据调用API
          visionCompletion(compressedBase64, prompt)
            .then(resolve)
            .catch(error => {
              // 如果API调用失败，尝试进一步压缩图片
              if (error.response && (error.response.status === 413 || error.response.status === 400)) {
                console.warn('图片可能仍然太大，尝试进一步压缩...')

                // 进一步降低质量和尺寸
                const furtherCompressedBase64 = canvas.toDataURL('image/jpeg', 0.3)

                // 再次调用API
                visionCompletion(furtherCompressedBase64, prompt)
                  .then(resolve)
                  .catch(reject)
              } else {
                reject(error)
              }
            })
        } catch (error) {
          console.error('图片压缩处理失败:', error)
          reject(error)
        }
      }

      // 图片加载错误处理
      img.onerror = (error) => {
        console.error('图片加载失败:', error)
        reject(new Error('图片加载失败'))
      }

      // 加载图片
      img.src = imageBase64
    }

    // 读取文件错误处理
    reader.onerror = (error) => {
      console.error('文件读取失败:', error)
      reject(error)
    }

    // 开始读取文件
    reader.readAsDataURL(imageFile)
  })
}

// 添加在文件末尾
export function deepThinkCompletion(prompt) {
  return axios({
    url: 'http://10.1.234.9:11434/api/generate',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      model: 'deepseek-r1:1.5b',
      prompt: `请先进行深入思考，分析问题的各个方面，然后给出最终答案。
思考格式如下：
思考过程：
[这里是你的分析过程，包括问题拆解、相关知识、推理步骤等]

最终回答：
[这里是你的最终答案]

问题：${prompt}`,
      stream: false
    },
    timeout: 120000,
    withCredentials: false // 修改为 false，不发送凭证
  }).then(response => {
    return {
      code: 1,
      data: response.data.response
    }
  })
}

// 去除红笔批改痕迹
export function removeMarks(imageFile) {
  return new Promise((resolve, reject) => {
    // 创建FormData
    const formData = new FormData()
    formData.append('image', imageFile)

    // 使用axios发送请求
    axios({
      url: 'http://123.56.176.195:8000/remove_marks/',
      method: 'post',
      data: formData,
      responseType: 'blob',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 300000, // 5分钟超时
      withCredentials: false,
      baseURL: '' // 明确指定baseURL为空，避免全局配置影响
    }).then(response => {
      // 创建处理后的图片URL
      const blob = new Blob([response.data], { type: 'image/jpeg' })
      const processedImageUrl = URL.createObjectURL(blob)

      resolve({
        success: true,
        data: processedImageUrl,
        blob: blob
      })
    }).catch(error => {
      console.error('去除红笔批改痕迹失败:', error)
      reject(error)
    })
  })
}
